/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
export const MAPPERS = {
    u16: {
        bool: (v: number) => v !== 0,
        u8: (v: number) => v & 0xff,
        i8: (v: number) => {
            const u = v & 0xff;
            return u > 0x7f ? u - 0x100 : u;
        },
        u16: (v: number) => v & 0xffff,
        i16: (v: number) => (v > 0x7fff ? v - 0x10000 : v),
    },
    i16: {
        u16: (v: number) => v & 0xffff,
    },
    u16s: {
        i32: (v: [number, number]) => {
            const view = new DataView(new ArrayBuffer(4));
            view.setUint16(0, v[0]);
            view.setUint16(2, v[1]);
            return view.getInt32(0);
        },
        u32: (v: [number, number]) => {
            const view = new DataView(new ArrayBuffer(4));
            view.setUint16(0, v[0]);
            view.setUint16(2, v[1]);
            return view.getUint32(0);
        },
        f32: (v: [number, number]) => {
            const view = new DataView(new ArrayBuffer(4));
            view.setUint16(0, v[0]);
            view.setUint16(2, v[1]);
            return view.getFloat32(0);
        },
        f64: (v: [number, number, number, number]) => {
            const view = new DataView(new ArrayBuffer(8));
            view.setUint16(0, v[0]);
            view.setUint16(2, v[1]);
            view.setUint16(4, v[2]);
            view.setUint16(6, v[3]);
            return view.getFloat64(0);
        },
        utf8str: (v: number[]) => String.fromCharCode(...v.filter((d) => d !== 0)),
        ipv4: (v: [number, number, number, number]) => v.join("."),
        mac: (v: [number, number, number, number, number, number]) =>
            v.map((d) => d.toString(16).padStart(2, "0")).join(":"),
        hexWordsStr: (v: number[]) => v.map((d) => d.toString(16).padStart(4, "0")).join(" "),
        hexBytesStr: (v: number[]) =>
            v.map((d) => (d & 0xff).toString(16).padStart(2, "0")).join(" "),
    },
    u32: {
        u16s: (v: number): [number, number] => {
            const view = new DataView(new ArrayBuffer(4));
            view.setUint32(0, v);
            return [view.getUint16(0), view.getUint16(2)];
        },
    },
    i32: {
        u16s: (v: number): [number, number] => {
            const view = new DataView(new ArrayBuffer(4));
            view.setInt32(0, v);
            return [view.getUint16(0), view.getUint16(2)];
        },
    },
    f32: {
        u16s: (v: number): [number, number] => {
            const view = new DataView(new ArrayBuffer(4));
            view.setFloat32(0, v);
            return [view.getUint16(0), view.getUint16(2)];
        },
    },
    bool: {
        u16: (v: boolean) => (v ? 1 : 0),
    },
};
